import React from 'react';
import { motion } from 'framer-motion';

// Three paths: Feel, Weigh, Translate
// Order: Feel first, then Weigh, then Translate
const paths = [
  { id: 'feel', label: 'Feel', sceneIndex: 11 },
  { id: 'weigh', label: 'Weigh', sceneIndex: 17 },
  { id: 'translate', label: 'Translate', sceneIndex: 24 }
];

const PathChoice = ({ onSelect }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 2, ease: [0.25, 0.1, 0.25, 1] }}
      className="fixed inset-0 flex flex-col items-center justify-center z-20 px-6"
    >
      {/* Floating path choices - centered in viewport */}
      <div className="flex flex-col items-center gap-10 sm:gap-12">
        {/* The three paths - appear sequentially */}
        <div className="flex flex-col sm:flex-row items-center gap-10 sm:gap-20">
          {paths.map((path, index) => (
            <motion.button
              key={path.id}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 1.8, 
                delay: index * 0.8, // Feel at 0s, Weigh at 0.8s, Translate at 1.6s
                ease: [0.25, 0.1, 0.25, 1]
              }}
              onClick={() => onSelect(path.id, path.sceneIndex)}
              className="group relative px-8 py-4 transition-all duration-1000"
            >
              <span 
                className="font-display text-3xl sm:text-4xl md:text-5xl tracking-[0.15em] transition-all duration-1000 group-hover:tracking-[0.25em]"
                style={{ color: 'hsl(40, 15%, 70%)' }}
              >
                {path.label}
              </span>
              
              {/* Subtle underline on hover */}
              <motion.div
                className="absolute bottom-2 left-1/2 -translate-x-1/2 h-px opacity-0 group-hover:opacity-40 transition-opacity duration-1000"
                style={{ 
                  width: '80%',
                  backgroundColor: 'hsl(38, 25%, 55%)'
                }}
              />
            </motion.button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default PathChoice;
